/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IUpdateHoundStamina,
  IUpdateHoundStaminaInterface,
} from "../IUpdateHoundStamina";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "houndId",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "amount",
        type: "uint32",
      },
    ],
    name: "updateHoundStamina",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IUpdateHoundStamina__factory {
  static readonly abi = _abi;
  static createInterface(): IUpdateHoundStaminaInterface {
    return new utils.Interface(_abi) as IUpdateHoundStaminaInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IUpdateHoundStamina {
    return new Contract(address, _abi, signerOrProvider) as IUpdateHoundStamina;
  }
}
